import { Toaster } from "react-hot-toast";
import { useMediaQuery } from "@aitisal/ui/hooks/useMediaQuery";

const ToastWindow = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div className="w-full">
      <Toaster
        position={isMobile ? "top-center" : "top-right"}
        reverseOrder={true}
      />
      {children}
    </div>
  );
};

export default ToastWindow;
